// extracted by mini-css-extract-plugin
export default {"form_group":"Checkbox_form_group__uuOlM","scaleUp":"Checkbox_scaleUp__kIKTa","form_groupSMALL":"Checkbox_form_groupSMALL__aB0Uf"};